<div class="page-wrapper supplier-detail-page">
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div *ngIf="roleUser == '[Extranet - Adhérent]'">
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > <a routerLink="/suppliers">Fournisseurs</a> >
          {{ detailSupplier?.companyName }}
        </div>
        <div *ngIf="roleUser == '[Extranet - Fournisseur]'">
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Mon espace fournisseur >
          {{ detailSupplier?.companyName }}
        </div>
      </div>
    </div>
  </div>
  <div class="supplier-detail-page-inner">
    <div class="container">
      <div class="wrap-title d-flex align-items-center">
        <img src="{{ logo }}" alt="" />
        <div>
          <h2 class="title mb-0">{{ detailSupplier?.companyName }}</h2>
          <button routerLink="/catalogues/suppliers/{{detailSupplier?.code}}"
            class="btn-common btn-catalogue">CATALOGUE</button>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="info-general d-flex">
        <div class="block-left">
          <p>Code : <span>{{ detailSupplier?.code }}</span></p>
          <p>SIRET : <span>{{ detailSupplier?.siret }}</span></p>
        </div>
        <div class="block-right">
          <p class="title">Coordonnées</p>
          <div class="d-flex justify-content-between gap-2 group-info-general flex-wrap">
            <div>
              <p>Téléphone :</p>
              <a href="tel:{{detailSupplier?.phone}}">{{ detailSupplier?.phone ? detailSupplier?.phone : '' }}</a>
            </div>
            <div>
              <p>Fax :</p>
              <a href="tel:{{detailSupplier?.fax}}">+{{ detailSupplier?.fax ? detailSupplier?.fax : '' }}</a>
            </div>
            <div>
              <p>Email :</p>
              <a href="mailto:{{detailSupplier?.email}}">{{ detailSupplier?.email ? detailSupplier?.email : ''
                }}</a>
            </div>
            <div>
              <p>Site web :</p>
              <a href="{{detailSupplier?.website}}">{{ detailSupplier?.website ? detailSupplier?.website : '' }}</a>
            </div>
            <div>
              <p class="address">
                Adresse :
                <span>{{detailSupplier?.address}}<br />
                  {{detailSupplier?.postcode}}, {{detailSupplier?.city}}{{detailSupplier?.country?.labels?.fr_FR && ', '
                  + detailSupplier?.country?.labels?.fr_FR }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="block-end" *ngIf="userService.hasExtranetAccess('fonctions', 'document-fournisseurs')">
          <p class="title">Pièces jointes</p>
          <div class="d-flex flex-column justify-content-between gap-2 group-info-general group-file-general">
            <div class="group-file d-flex flex-column gap-2 flex-wrap">
              <div [matTooltip]="item?.nameFileDetail" *ngFor="let item of listFileSupplier" class="wrap-file p-2">
                <a class="" (click)="openFile(item)" target="_blank">
                  <img src="src-adisco/assets/images/icon/file-text.png" alt="">
                  <div class="wrap-text">
                    <p class="mb-0 font-bold">{{item?.nameFile}}</p>
                    <p class="mb-0">{{item?.nameFileDetail}}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="wrap-contacts py-5">
      <div class="container">
        <h3 class="title text-center">CONTACTS</h3>
        <div class="wrap-table">
          <p-table [value]="contactData">
            <ng-template pTemplate="header">
              <tr>
                <th class="font-bold" style="min-width: 180px">Fonction</th>
                <th class="font-bold">Prénom</th>
                <th class="font-bold" style="min-width: 135px">Nom</th>
                <th class="font-bold" style="min-width: 150px; max-width: 150px">
                  Téléphone
                </th>
                <th class="font-bold">Portable</th>
                <th class="font-bold" style="width: 200px">Email</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td class="font-bold">{{ item?.job ? item?.job : '-' }}</td>
                <td class="">{{ item?.firstName ? item?.firstName : '-' }}</td>
                <td class="">{{ item?.lastName ? item?.lastName : '-' }}</td>
                <td class="underline">
                  <a *ngIf="item?.phone" href="tel:{{ item?.phone }}">{{ item?.phone }}</a>
                  <p *ngIf="!item?.phone">-</p>
                </td>
                <td class="underline">
                  <a *ngIf="item['mobile ']" [href]="'tel:' + item['mobile ']">{{ item['mobile '] }}</a>
                  <p *ngIf="!item['mobile ']">-</p>
                </td>
                <td class="underline">
                  <a *ngIf="item?.email" href="mailto:{{ item?.email }}">{{ item?.email }}</a>
                  <p *ngIf="!item?.email">-</p>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div *ngIf="listNews.length > 0" class="wrap-slides bg-white py-5">
      <div class="container">
        <h3 class="title text-center">ACTUALITÉS</h3>
        <app-slide-news [listNewsInput]="listNews"></app-slide-news>
      </div>
    </div>
    <div *ngIf="listTrainingNews.length > 0" class="wrap-slides bg-f3 py-5">
      <div class="container">
        <h3 class="title text-center">FORMATIONS</h3>
        <app-slide-news [listNewsInput]="listTrainingNews"></app-slide-news>
      </div>
    </div>
    <div *ngIf="listMarketingNews.length > 0" class="wrap-slides bg-white py-5">
      <div class="container">
        <h3 class="title text-center">MARKETING</h3>
        <app-slide-news [listNewsInput]="listMarketingNews"></app-slide-news>
      </div>
    </div>
    <div *ngIf="listPromotionNews.length > 0" class="wrap-slides bg-f3 py-5">
      <div class="container">
        <h3 class="title text-center">PROMOTIONS</h3>
        <app-slide-news [listNewsInput]="listPromotionNews"></app-slide-news>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Fichier d'aperçu" [modal]="true" [(visible)]="visibleItem" [style]="{ width: '70%' }">
  <div class="popup-del-row">
    <div class="w-100 text-end">
      <a href="#" (click)="onDownload($event)" class="btn-common p-2">Télécharger</a>
    </div>
    <div id="outerContainer">
      <div class="pdf-container" [ngClass]="{'loaded' : pdfLoaded}">
        <pdf-viewer [src]="itemPdfShow?.urlFile || ''" [rotation]="0" [original-size]="false" [show-all]="true"
          [fit-to-page]="false" [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
          [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false"
          style="max-width: 100; width: 100%; height: 100vh;" (page-rendered)="pageRendered($event)"
          (after-load-complete)="pageProgress($event)"></pdf-viewer>
      </div>
    </div>
  </div>
</p-dialog>